import * as React from 'react';
export const usaaSvg = React.forwardRef(function usaaSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#102941',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M16.72 12.77s8.23 4.38 8.48 4.46c.25.08.76.08.93 0 .17-.08.68-.39.68-.39v1.92s-.5.31-.68.39c-.17.08-.6.08-.93 0-.34-.08-7.89-4.15-7.89-4.15l-.59-2.23zm.76 2.85s7.47 3.99 7.72 4.07c.25.07.76.07.93 0 .17-.08.68-.39.68-.39v1.92s-.5.3-.68.39c-.17.07-.6.07-.93 0a233.52 233.52 0 0 1-7.2-3.77l-.52-2.22zm.77 2.91s6.7 3.61 6.95 3.69c.25.08.76.08.93 0 .17-.08.68-.38.68-.38v1.92s-.5.3-.68.38c-.17.08-.6.08-.93 0-.34-.08-6.44-3.46-6.44-3.46l-.51-2.15zm-4.41-.38s-6.79-3.6-7.04-3.69a1.9 1.9 0 0 0-.93 0c-.17.08-.68.39-.68.39v-1.92s.5-.3.68-.39c.17-.07.6-.07.93 0 .34.08 7.46 3.92 7.46 3.92l-.42 1.69zm-.51 2.23S7.05 17.08 6.8 17a1.9 1.9 0 0 0-.93 0c-.17.08-.68.38-.68.38v-1.92s.5-.3.68-.38c.17-.08.6-.08.93 0 .32.07 6.95 3.6 6.95 3.6l-.42 1.7zm-.6 2.15s-5.68-3-5.93-3.07a1.9 1.9 0 0 0-.93 0c-.17.07-.68.38-.68.38v-1.92s.5-.3.68-.38c.17-.08.6-.08.93 0 .34.07 6.36 3.3 6.36 3.3l-.42 1.69zm.43-9.14s1.27-4.92 1.36-5.07c.08-.15.08-.3.5-.38.23-.04.64-.14 1.1-.14.44 0 .95.1 1.1.14.35.07.52.3.52.3h1.19c.25 0 .59.39.59.54 0 .16 0 .7-.09.85-.08.15-.08 0-.08 0-.11-.13-.17-.39-.26-.39-.08 0-1.18.39-1.18.39l.42 1.53s6.45 3.38 6.78 3.53c.34.16.68.08 1.02 0 .34-.07.68-.3.68-.3v1.92s-.42.23-.68.3c-.25.08-.85.08-1.02 0-.16-.07-8.56-4.45-8.56-4.45l-.6-2.23L14.44 16l-7.71-4a1.02 1.02 0 0 0-.68 0c-.26.08-.85.31-.85.31V10.4s.42-.23.76-.3c.34-.08.6-.08.94 0a186 186 0 0 1 6.27 3.3z',
      }),
    ),
  );
});
usaaSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var usaa = {
  category: 'brand',
  colorable: false,
  name: 'usaa',
  svg: usaaSvg,
};
